import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/index'
import Recollection from '@/pages/Recollection/index'
import Remember from '@/pages/Remember/index'
import Remembrance from '@/pages/Remembrance/index'
import Resistance from '@/pages/Resistance/index'
import Details from '@/pages/Details/index'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Recollection',
      name: 'Recollection',
      component: Recollection
    },
    {
      path: '/Remember',
      name: 'Remember',
      component: Remember
    },
    {
      path: '/Remembrance',
      name: 'Remembrance',
      component: Remembrance
    },
    {
      path: '/Resistance',
      name: 'Resistance',
      component: Resistance
    },
    {
      path: '/Details/:id',
      name: 'Details',
      component: Details
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js